import { LitElement, TemplateResult, css, html } from 'lit';
import { customElement, property } from 'lit/decorators.js';
import { unsafeHTML } from 'lit/directives/unsafe-html.js';
import '../../design-system/button/button';
import resetStyle from '../../shared/components/html-content/reset.style';
import '../../shared/components/svg-image/svg-image';
import { overrideDesignTokens } from '../../shared/styles/override-design-tokens';
import { ludsSpacing } from '../../shared/styles/spacing';
import { ludsBaseFont, ludsTypography, ludsTypographyFontWeight, ludsHeadingXS } from '../../shared/styles/typography';
import { lu_screen_s } from '../../shared/styles/breakpoint';
import '../../shared/components/svg-image/svg-image';
import '../../design-system/button/button';
import { ButtonVariants } from '../../shared/types/button.model';

export interface CompletionItem {
  icon: string;
  title: string | TemplateResult;
  description: string | TemplateResult;
  buttons?: Array<{
    label: string | TemplateResult;
    action: () => void;
    variant?: ButtonVariants;
  }>;
}

@customElement('lua-completion-item')
export class LuaCompletionItem extends LitElement {
  static override styles = [
    resetStyle,
    overrideDesignTokens,
    ludsBaseFont,
    ludsTypography,
    ludsTypographyFontWeight,
    ludsHeadingXS,
    ludsSpacing,
    css`
      .item {
        display: flex;
        align-items: center;
        justify-content: space-between;
        flex-wrap: wrap;
        gap: var(--spacing-spacing-16);

        .actions {
          display: flex;
          gap: var(--spacing-spacing-08);
          flex-wrap: wrap;
        }

        .text {
          text-align: left;
          flex-grow: 1;

          p {
            margin: 0;
          }
        }
      }

      @container (min-width: ${lu_screen_s}px) {
        .item .actions {
          flex-wrap: nowrap;
        }
      }
    `,
  ];

  @property({ type: String }) icon = '';
  @property({ type: String }) itemTitle: string | TemplateResult;
  @property({ type: String }) description: string | TemplateResult = '';
  @property({ type: Array }) buttons: Array<{
    label: string | TemplateResult;
    action: () => void;
    variant?: ButtonVariants;
  }> = [];

  protected override render() {
    return html` <div class="item">
      ${this.icon ? html`<lua-svg-image width="64" height="64" name=${this.icon}></lua-svg-image>` : null}
      <div class="text">
        <h2 class="h-xs fw-600">${this.itemTitle}</h2>
        <p class="p-default">
          ${typeof this.description === 'string' ? unsafeHTML(this.description) : this.description}
        </p>
      </div>
      <div class="actions">
        ${this.buttons?.map(
          (button) =>
            html`<luds-button @click="${button.action}" variant="${button.variant ?? 'secondary'}"
              >${button.label}</luds-button
            >`
        )}
      </div>
    </div>`;
  }
}

declare global {
  interface HTMLElementTagNameMap {
    'lua-completion-item': LuaCompletionItem;
  }
}
